<h1>
    Annulation d'abonnement LyBox
    <span>Sans engagements, Résiliables à tout moment</span>
</h1>
<div class="row">
    <div class="col-lg-12">
        <div class="card main-card">
            <div class="card-body">
                <div class="container-fluid">
                    <div class="row">
                        <div class="colWidget col-md-12">
                            <iframe id="gform" [src]="url | safe" width="640" height="1320" frameborder="0" marginheight="0" marginwidth="0">
                                Chargement…
                            </iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
